<template>
  <div>
    <div style="width: 100%;height:100vh;position: relative;background:RGBA(246, 246, 246, 1)" id="homePage">
      <happy-scroll color="#e7534d" size="5" hide-horizontal resize>
        <div id="homePage" style="width:100vw;display: flex;flex-direction: column;">
          <div style="flex: 1;">
            <Menu></Menu>
            <router-view></router-view>
          </div>
          <div style="flex: 0 0 4.975rem;">
            <Footer></Footer>
          </div>
        </div>
      </happy-scroll>
    </div>
  </div>

</template>
<script>
  import { HappyScroll } from 'vue-happy-scroll'
  // 引入css，推荐将css放入main入口中引入一次即可。
  import 'vue-happy-scroll/docs/happy-scroll.css'
  import Menu from "@/components/Menu";
  import Footer from "@/components/Footer";
  export default{
    name:'home',
    data(){
      return {

      }
    },
    destroyed(){

    },
    mounted() {
    },
    components:{Menu, Footer, 'happy-scroll': HappyScroll},
    computed: {

    },
    methods:{
    },
  }
</script>
<style>
  .happy-scroll-container{
    width: 100%!important;
  }
 .happy-scroll-content{
   width: 100%;
   border-bottom: none!important;
   border-top: none!important;
 }
  *::-webkit-scrollbar {
    	display: none;
    }
  * {
  	scrollbar-width: none;
  }
  * {
  	-ms-overflow-style: none;
  }
  .happy-scroll-strip--vertical .happy-scroll-bar{
    opacity: 1!important;
  }
  .happy-scroll-strip--vertical{
    z-index: 7000;
    background:#fff
  }
  .happy-scroll-strip--vertical .happy-scroll-bar{
    background:#fff;
    box-shadow: 1px;
  }
  .happy-scroll-strip--horizontal .happy-scroll-bar {
      border-radius: 7px;
      background:#fff;
      height: 6px!important;
      width: 0;
      -webkit-transition: height 0.4s ease, width 0.6s ease;
      transition: height 0.4s ease, width 0.6s ease;
  }
  .happy-scroll{

  }
  .happy-scroll-container{
    height: 100%!important;
  }
</style>
<style lang="less" scoped>
  #homePage{
    min-height: 100vh;
  }
  .consultTop{
    width: 100%;
    height: 9.25rem;
    padding: 1.2125rem 4.325rem 0 3rem;
    box-sizing: border-box;
    background-image: url(./image/consult.png);
    background-size: 100% 100%;
  }
  .consultTop1{
    width: 100%;
    height: 100%;
    display: flex;
  }
  .consultTop1l{
    flex: 1;
  }
  .consultTop1r{
    flex: 0 0 4.5375rem;
    width: 4.5375rem;
    height: 6.825rem;
    background: #EE564F;
    border-radius: 0.05rem;
  }
  .consultTop1ltxt{
    font-size: 0.275rem;
    display: inline-block;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    position: relative;
  }
  .consultTop1ltxt:before{
    position: absolute;
    width: 0.05rem;
    height: 0.25rem;
    top: 50%;
    left: -0.1rem;
    transform: translate(-50%,-50%);
    content:'';
    background:red
  }
  .consultTime{
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 0.375rem;
    margin-bottom: 0.225rem;
  }
  .consultTime1{
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-bottom: 0.5875rem;
  }
  .consultTxt2{
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    margin-bottom: 0.6125rem;
    margin-left: -0.125rem;
  }
  .consultTxt3{
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 0.375rem;
    line-height: 0.375rem;
  }
  .consultright{
    width: 1.875rem;
    height: 0.5rem;
    line-height: 0.5rem;
    background: #fff;
    margin: 0 auto;
    border-radius: 0 0 0.25rem 0.25rem;
    font-size: 0.25rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #EE564F;
    text-align: center;
  }
  .consultrTxt{
    font-size: 0.2rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 0.375rem;
    width: 100%;height: 4.5rem;padding: 0.375rem;box-sizing: border-box;
  }
  .selfAppoint{
    width: 3.6875rem;
    height: 0.625rem;
    border: 1px solid #FFFFFF;
    border-radius: 0.3125rem;
    margin: 0 auto;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 0.625rem;
    text-align: center;
    cursor: pointer;
  }
  .selfAppoint:hover{
    background-color: #fff;
    color: rgba(238, 86, 79, 1);
  }
  .selfAppoint1{
    background-color: #fff;
    color: rgba(238, 86, 79, 1);
  }
  .wjdcSty{
    font-size: 0.375rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #222222;
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
  }
  .wjdcImg{
    width: 100%;
    height: auto;
  }
  .wjdcTxt{
    width: 100%;
    padding: 0.5rem 0.525rem;
    box-sizing: border-box;
    background: #FFFFFF;
    border-radius: 0.05rem;
    font-size: 0.225rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
    line-height: 0.475rem;
  }
  .swiper-pagination{
    width: 100%;
    text-align: center;
    margin-top: 0.375rem;
  }
  .swiper-pagination-clickable /deep/ .swiper-pagination-bullet{
    margin-right: 0.125rem;
  }
  /deep/ .swiper-pagination-bullet-active{
    background: rgba(238, 86, 79, 1)!important;
  }
  .consultly{
    padding: 0.3rem 0.5rem 0 0.5rem;margin-bottom: 0.625rem;width: 100%;background-color: #fff;
  }
  .consultly1{
    padding:0.5rem 0;border-bottom: 1px solid #E5E5E5;
  }
  .consultly2{
    display: flex;width: 100%;align-items:center;
  }
  .consultly3{
    flex: 0 0 0.875rem;width: 0.875rem;height: 0.875rem;
  }
  .consultly4{
    flex: 1;padding-left: 0.35rem;width: 100%;box-sizing: border-box;
  }
  .consultly5{
    font-size: 0.25rem;font-family: Microsoft YaHei;font-weight: bold;color: #222222;line-height: 0.375rem;
  }
  .consultly6{
    font-size: 0.225rem;font-family: Microsoft YaHei;font-weight: 400;color: #222222;line-height: 0.375rem;
  }
  .consultly7{
    flex: 0 0 1.5rem;font-size: 0.2rem;font-family: Microsoft YaHei;font-weight: bold;color: #222222;
  }
  .consultly8{
    margin-top: 0.25rem;padding-left: 1.25rem;box-sizing: border-box;
  }
  .consultly9{
    display: flex;width: 100%;padding:0.1rem 0.375rem;box-sizing: border-box;
    background: #F8F8F8;min-height: 1.5rem;align-items: center;
  }
  .consultly10{
    flex: 0 0 0.875rem;width: 0.875rem;height: 0.875rem;
  }
  .consultly11{
    flex: 1;padding-left: 0.35rem;width: 100%;box-sizing: border-box;
  }
  .consultly12{
    font-size: 0.25rem;font-family: Microsoft YaHei;font-weight: bold;color: #222222;line-height: 0.375rem;
  }
  .consultly13{
    font-size: 0.225rem;font-family: Microsoft YaHei;font-weight: 400;color: #222222;line-height: 0.375rem;
  }
  .consultly1:last-child{
    border-bottom: none;
  }
  .selfBut{

  }
  .selfBut .el-button{
    width: 1.925rem;
    height: 0.6375rem;
    line-height: 0.6375rem;
    padding: 0;
    background: #EE564F;
    border-radius: 0.0875rem;
    font-size: 0.25rem;
    color: #FFFFFF;
  }
  .selfBut .el-form-item{
    height: 0.925rem;
    line-height: 0.925rem;
  }
  .selfBut /deep/ .el-form-item__label{
    height: 0.925rem;
    line-height: 0.925rem;
    text-align: right;
    font-size: 0.275rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #222222;
  }
  .selfBut /deep/ .el-input__inner{
    width: 7.875rem;
    height: 0.925rem;
    background: #F5F8FC;
    color: #000;
    // border: 1px solid #EE564F;
    border-radius: 0.0875rem;
  }
  .selfBut /deep/ .el-textarea__inner{
    min-height: 2.6875rem!important;
    width:7.875rem;
    background: #F5F8FC;
    color: #000;
    border-radius: 0.0875rem;
  }
  .addSty .el-button{
    width: 1.25rem;
    height: 0.6375rem;
    background: #EE564F;
    border-radius: 0.0875rem;
    font-size: 0.25rem;
    color: #FFFFFF;
    line-height: 0.6375rem;
    padding: 0;
  }
  .prevStep.el-button{
    width: 3.75rem;
    height: 0.975rem;
    border: 0.0125rem solid #5C5DF6;
    border-radius: 0.05rem;
    font-size: 0.3rem;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #5C5DF6;
    line-height: 0.975rem;
    padding: 0;
    margin-top: 1.75rem;
  }
  .submitStep.el-button{
    width: 3.75rem;
    height: 0.975rem;
    padding: 0;
    line-height: 0.975rem;
    background: #5C5DF6;
    border-radius: 0.05rem;
    font-size: 0.3rem;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 0.5rem;
  }
  .tjSty .el-form-item__content{
    margin-left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/consult/index.vue